import React, { FC, ReactNode } from 'react'
import { Box, Tooltip, useTheme, makeStyles } from '@material-ui/core'
import { ReactComponent as InfoIcon } from 'assets/svg/InfoIcon.svg'
import DatePicker from 'UI/DatePicker/DatePicker'
import { DatePickerProps } from '@material-ui/pickers'

const useStyles = makeStyles((theme) => ({
  customLabel: {
    // Hide the tooltip wrapper when the label is NOT shrunk (resting inside the input)
    '&:not(.MuiInputLabel-shrink) $tooltipWrapper': {
      opacity: 0,
      visibility: 'hidden',
      pointerEvents: 'none',
    },
  },
  labelContainer: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  tooltipWrapper: {
    marginLeft: theme.spacing(1),
    display: 'inline-flex',
    verticalAlign: 'middle',
    pointerEvents: 'auto',
    marginTop: '-2px',
  },
}))

interface IDatePickerWithTooltipProps extends Omit<DatePickerProps, 'label'> {
  label: ReactNode
  tooltipText: string | ReactNode
}

const DatePickerWithTooltip: FC<IDatePickerWithTooltipProps> = ({
  label,
  tooltipText,
  InputLabelProps,
  ...restProps
}) => {
  const s = useStyles()
  const theme = useTheme()

  // Build the combined Label + Tooltip UI
  const labelWithIcon = (
    <Box component="span" className={s.labelContainer}>
      {label}
      <Tooltip placement="top" title={tooltipText ?? ''}>
        <Box component="span" className={s.tooltipWrapper}>
          <InfoIcon
            width={16}
            height={16}
            color={theme.palette.text.disabled}
            style={{ cursor: 'pointer' }}
          />
        </Box>
      </Tooltip>
    </Box>
  )

  // Render your existing DatePicker, injecting our custom label and CSS class
  return (
    <DatePicker
      label={labelWithIcon}
      {...restProps}
      InputLabelProps={{
        ...InputLabelProps,
        className: `${s.customLabel} ${InputLabelProps?.className || ''}`,
      }}
    />
  )
}

export default DatePickerWithTooltip